import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'reducer/store';

interface IretailerIds {
  retailerName: string;
  retailerId: string;
}

export interface IuserInfo {
  userId: string;
  role: string;
  retailerIds: IretailerIds[];
  glnCode: { SSE: string; CSM: string };
  supplierCode: { SSE: string; CSM: string };
  accessCode: { SSE: string; CSM: string };
}

const initialState: IuserInfo = {
  userId: '',
  role: '',
  retailerIds: [],
  glnCode: { SSE: '', CSM: '' },
  supplierCode: { SSE: '', CSM: '' },
  accessCode: { SSE: '', CSM: '' },
};

const userInfo = createSlice({
  name: 'setUserInfo',
  initialState,
  reducers: {
    setUserInfoRedux: (state, action: PayloadAction<IuserInfo>) =>
      action.payload,
  },
});
// 取值 get
export const getUserInfoReducer = (state: RootState) => state.userInfoReducer;
// set
export const userInfoAction = userInfo.actions;
const userInfoReducer = userInfo.reducer;
export default userInfoReducer;
